import { s } from "../internals/set-species.js";
s("Array");